var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"mr-3",attrs:{"variant":"light"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('font-awesome-icon',{attrs:{"icon":'chevron-left'}}),_vm._v(" "+_vm._s(_vm.$t('Back'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }